import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { CarBenefitListItemExtension } from './car-benefit-list-item.extension';
import { CarBenefitMetadataExtension } from './car-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('car')
    .add(BenefitMetadataExtensionInterface, new CarBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new CarBenefitListItemExtension())
    .build(),
);
